import PropTypes from 'prop-types';
import Platform from "react-native-web/dist/exports/Platform";
import getPropSelector from './getPropSelector';

// These are the props accepted specifically on React Native (Web) `Text` elements.
// They are generally concerned with the behaviour of multiline text.

const crossPlatform = {
  /**
   * Truncates text after this many lines with an ellipsis at the end.
   * On native, ellipsis behaviour may be changed with `ellipsizeMode` prop.
   */
  numberOfLines: PropTypes.number,
  /**
   * Default is true on web and false on native
   */
  selectable: PropTypes.bool
};

/**
 * See React Native docs for latest details on these.
 * https://reactnative.dev/docs/text
 */
const nativeOnly = {
  ellipsizeMode: PropTypes.string,
  maxFontSizeMultiplier: PropTypes.number,
  minimumFontScale: PropTypes.number,
  onTextLayout: PropTypes.func,
  suppressHighlighting: PropTypes.bool,
  textBreakStrategy: PropTypes.string
};

/**
 * These set HTML attributes of the same name.
 */
const webOnly = {
  dir: PropTypes.oneOf(['auto', 'ltr', 'rtl']),
  lang: PropTypes.string
};
export default {
  /**
   * Set of prop types specific to React Native and React Native Web `Text`,
   * which largely revolve around the behaviour of multiline non-pressable text.
   */
  types: {
    ...crossPlatform,
    ...webOnly,
    ...nativeOnly
  },
  /**
   * Filters a props object, returning only props specific to `Text` elements
   * on the current platform. Does not include props applicable to `Text` and `View`.
   */
  select: getPropSelector({
    ...crossPlatform,
    ...Platform.select({
      web: webOnly,
      default: nativeOnly
    })
  })
};